import React, {useState} from 'react';
import Checkin from '../InfoGlobalComponents/Checkin';
import Note from '../InfoGlobalComponents/Note';
import TodoList from '../InfoGlobalComponents/TodoList';
import Photo from '../InfoGlobalComponents/Photo';
import PDF from '../InfoGlobalComponents/PDF'
import moment from 'moment-timezone';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleRight, faAngleLeft} from '@fortawesome/free-solid-svg-icons';

/**
 *  InfoGlobalBase
 * @return {JSX}
 */
function InfoGlobalHistoriqueView(props) {

  const [checkedGraph, setCheckedGraph] = useState(false);

  const handleCheckedGraph = () => {
    setCheckedGraph(!checkedGraph);
  };


  const formatDate = (dateString) => {
    const date = moment.tz(dateString, 'America/Montreal');
    const dayNames = {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    };
    moment.locale('fr'); // set locale to French
    const dayName = dayNames[date.format('dddd')];
    return `${dayName} le ${date.format('DD-MM-YYYY')}`;
  };

  return (
    <React.Fragment>

    <React.Fragment>
            <label className="checkin-toggle-switch-label">Voir graphique ?</label>
            <div className="toggle-switch checkin-toggle-switch" >
              <div>
                <input
                  id="toggle"
                  type="checkbox"
                  checked={checkedGraph}
                  onChange={handleCheckedGraph} />
                <label htmlFor="toggle"></label>
              </div>
              <div>
              </div>
            </div>
          </React.Fragment>
          <div className="banktable-week d-flex justify-content-between align-items-center">
        <div>{props.date}</div>
        <div className="d-flex justify-content-between">
          <div>
            <button
              className="banktable-pagination-button banktable-pagination-button-left"
              onClick={() => props.previous()}
              >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <button
              className="banktable-pagination-button"
              onClick={() => props.next()}
              disabled={props.week === 0}>
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>
        </div>
      </div>

      {props.infoGlobal.length === 0 ? <h1>Rien à afficher</h1> : ""}
          {props.infoGlobal.map((item, index) => {
             if (item.type === 'checkin')
             return <Checkin key={index} checkin={item} formatDate={formatDate} checkedGraph={checkedGraph}/>;
            else if (item.type === 'note')
             return <Note key={index} note={item} formatDate={formatDate} />;
            else if (item.type === 'todolist')
             return <TodoList key={index} todolist={item} formatDate={formatDate} />;
            else if (item.type === 'photo' || item.type === 'facture')
             return <Photo key={index} photo={item} formatDate={formatDate} />;
            else if (item.type === 'file')
             return <PDF key={index} file={item} formatDate={formatDate} />;
            
          })}
        </React.Fragment>
  );
}

export default InfoGlobalHistoriqueView;
